import React, {useEffect, useRef} from 'react';

const DropdownContainer = ({children, disableState, style, className}) => {

    const useOutsideAlerter = ref => {
        const handleClickOutside = event => {
            if (ref.current && !ref.current.contains(event.target)) {
                disableState(false);
            }
        };

        useEffect(() => {
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        });
    };

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    return (
        <div className={className} style={style} ref={wrapperRef}>
            {children}
        </div>
    )
};

export default DropdownContainer;